import type { Parceiro } from "./tipos"

// Convenia (convenia.com.br), software de RH que leva o consignado aos clientes dela. Cores e
// fontes tiradas do site deles: o azul-marinho da marca nas superfícies e o ciano como neutro dos
// gráficos — o marinho ao lado do cinza de "perdemos" quase some numa fatia fina.
//
// Sem arquivo oficial do logo ainda: o nome vai escrito na fonte e na cor da marca.
export const CONVENIA: Parceiro = {
    slug: "convenia",
    nome: "Convenia",
    doParceiro: "da Convenia",
    comArtigo: "a Convenia",
    tituloDaAba: "Convenia · Portal do Empregador",
    marca: { tipo: "texto", texto: "convenia" },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#13164e",
            "brand-ink": "#ffffff",
            "brand-strong": "#0d0f38",
            "brand-wash": "#e6e8f6",
            data: "#0091ae",
            page: "#f7f8f6",
            card: "#ffffff",
            sunk: "#eef1f5",
            ink: "#13164e",
            soft: "#1b2534",
            faint: "#5a6475",
            line: "#e2e8f0",
            "line-strong": "#c9cfc4",
        },
        escuro: {
            brand: "#8f97ee",
            "brand-ink": "#0e0f16",
            "brand-strong": "#aab0f4",
            "brand-wash": "#222752",
            data: "#4fc3dd",
            page: "#0e0f16",
            card: "#181a25",
            sunk: "#222533",
            ink: "#f0f4ef",
            soft: "#dbe0e8",
            faint: "#aeb6c2",
            line: "#2a2d3c",
            "line-strong": "#414658",
        },
    },
    fontes: {
        titulo: '"Bricolage Grotesque Variable", ui-sans-serif, system-ui, sans-serif',
        texto: '"Manrope Variable", ui-sans-serif, system-ui, sans-serif',
        numeros: '"Manrope Variable", ui-sans-serif, system-ui, sans-serif',
        carregar: () =>
            Promise.all([
                import("@fontsource-variable/manrope"),
                import("@fontsource-variable/bricolage-grotesque"),
            ]),
    },
}
